/* eslint-disable */
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { Typography } from "@material-ui/core";
import { useStyles } from "./FavouritesToolbar.styles";
import { BackButton } from "../../../basf-ui";
import { messages } from "./FavouritesToolbar.messages";

export const FavouritesToolbar: React.FC = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <BackButton />
      <Typography className={classes.titlePage}>
        <FormattedMessage {...messages.titlePage} />
      </Typography>
    </div>
  );
};
